module.exports = __webpack_public_path__ + "img/index-shareIns.936e268c.png";